import { Box, Flex, Input, Text } from "@chakra-ui/react";
import AppButton from "@/features/line-sheet-sets/app-button";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { toTitle } from "@/utils/case";
import SVG from "react-inlinesvg";

interface AppQueryInputProps {
  value?: string;
  width?: string;
  onChange?: (value: string) => void;
  showButton?: boolean;
  placeholder?: string;
  leadingIcon?: string;
  showIconsAndBtn?: boolean;
}

export default function AppQueryController({
  value = "",
  width = "288px",
  showButton = true,
  onChange,
  placeholder = "",
  leadingIcon,
  showIconsAndBtn,
}: AppQueryInputProps) {
  const [text, setText] = useState<string>(value);
  const { t } = useTranslation();

  useEffect(() => {
    setText(value);
  }, [value]);

  const submit = () => {
    if (onChange) {
      onChange(text);
    }
  };

  return (
    <Flex
      fontSize={"12px"}
      flexDirection={"row"}
      gap={"0px"}
      flexShrink={0}
      width={width}
      border={"1px solid #CBD5E0"}
      borderRadius={"4px"}
      overflow={"hidden"}
      _focusWithin={{
        border: "1px solid #3182ce",
        boxShadow: "0 0 0 1px #3182ce",
      }}
    >
      <Box position={leadingIcon ? "relative" : "static"} flex={1}>
        {leadingIcon && (
          <SVG
            src={`/icons-v1_1/${leadingIcon}.svg`}
            width={"20px"}
            height={"20px"}
            style={{
              position: "absolute",
              top: "50%",
              left: "6px",
              transform: "translateY(-50%)",
              zIndex: 1,
            }}
          />
        )}
        <Input
          padding={"0 8px"}
          margin={"0"}
          minHeight={"28px"}
          height={"28px"}
          fontSize={"inherit"}
          textAlign={"start"}
          paddingLeft={leadingIcon ? "26px" : "8px"}
          value={text}
          paddingRight={showButton ? "0px" : "26px"}
          placeholder={placeholder}
          border={"none"}
          tabIndex={0}
          _focus={{
            boxShadow: "none",
            border: "none",
          }}
          _hover={{
            border: "none",
          }}
          onChange={(event) => {
            //onChange(parseFloat(event.target.value));
            setText(event.target.value);
          }}
          onKeyDown={(event) => {
            if (event.key === "Enter") {
              event.preventDefault();
              submit();
            }
          }}
        />
        {(!showButton && !!text) ||
          (showIconsAndBtn && !!text && (
            <Box
              width="20px"
              height="20px"
              cursor="pointer"
              position="absolute"
              top="50%"
              right="6px"
              transform="translateY(-50%)"
              zIndex={10}
            >
              <SVG
                src="/icons-v1_1/x-circle-solid.svg"
                width={"20px"}
                height={"20px"}
                onClick={() => {
                  setText("");
                  if (onChange) {
                    onChange("");
                  }
                }}
              />
            </Box>
          ))}
      </Box>
      {showButton && (
        <Box
          borderLeft={"1px solid #CBD5E0"}
          display={"flex"}
          alignItems={"center"}
          padding={"0 8px"}
          cursor={"pointer"}
          _hover={{
            backgroundColor: "#f5f5f5",
          }}
          onClick={() => {
            submit();
          }}
          minWidth={"60px"}
          justifyContent={"center"}
        >
          <Text textStyle={"body-sm-bold"} color={"rgb(68, 68, 64)"}>
            {toTitle(t("search"))}
          </Text>
        </Box>
      )}
    </Flex>
  );
}
